"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoNotServiceArea = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.DoNotServiceArea = typebox_1.Type.Object({
    first_name: typebox_1.Type.String(),
    csa_name: typebox_1.Type.String(),
    service_location: typebox_1.Type.String(),
    service_type: typebox_1.Type.String(),
    custom_message: typebox_1.Type.String(),
    /**
     * as an empty string or in yyyy-mm-dd format
     */
    last_order_date: typebox_1.Type.String(),
});
//# sourceMappingURL=do-not-service-area.js.map